import React from 'react';
import { CheckIcon, FlameIcon, DownloadIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
const bundle = [{
  emoji: '🤖',
  label: 'MakerLab — Plus de 100 projets de robots',
  value: '$47,00'
}, {
  emoji: '🎥',
  label: 'Bonus n° 1 : Pack Arcade en carton',
  value: '$25,00'
}, {
  emoji: '✂️',
  label: 'Bonus n° 2 : Le guide des bricolages en papier en 5 minutes',
  value: '$19,00'
}, {
  emoji: '🌈',
  label: 'Bonus n° 3 : Petits créateurs : slime et jeux sensoriels',
  value: '$19,00'
}];
export function Offer() {
  return <section id="offre" className="w-full bg-cream py-16 sm:py-24" data-id="element-122" data-mp="13yc6fffg03nd">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-123" data-mp="ywwqu2w1apcd">
        <SectionHeading eyebrow="✦ Tout ce que vous recevez aujourd’hui" title={<>Le pack MakerLab complet</>} data-id="element-124" data-mp="2fc698up91el5" />

        <div className="mt-12 overflow-hidden rounded-3xl border border-ink/10 bg-white shadow-xl" data-id="element-125" data-mp="2ac1v3bbtcvy3">
          <ul className="divide-y divide-ink/10" data-id="element-126" data-mp="pjfis6gccfh2">
            {bundle.map(item => <li key={item.label} className="flex items-center justify-between gap-4 px-6 py-4" data-id="element-127" data-mp="ui8xu3ba0ejc">
                <span className="flex items-center gap-3 text-sm font-semibold text-ink" data-id="element-128" data-mp="zgajmw036ryi">
                  <span className="text-xl" aria-hidden="true" data-id="element-129" data-mp="13hw16unkfuf1">
                    {item.emoji}
                  </span>
                  {item.label}
                </span>
                <span className="flex-none text-sm font-medium text-ink/40 line-through" data-id="element-130" data-mp="btlvhskhi39g">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="space-y-2 bg-ink px-6 py-8 text-center text-white" data-id="element-131" data-mp="km5uiu4ou9ut">
            <p className="text-sm text-white/60" data-id="element-132" data-mp="3k95gy5ewyhdy">
              Valeur totale <span className="line-through" data-id="element-133" data-mp="3k6t3a4g6ut6p">$110,00</span>
            </p>
            <p className="flex items-center justify-center gap-2 text-sm font-semibold uppercase tracking-wide text-sunshine" data-id="element-134" data-mp="3o8o12yywuofq">
              <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-135" data-mp="vde8h62r6466" />
              Aujourd’hui seulement, vous payez
            </p>
            <p className="font-display text-5xl font-black" data-id="element-136" data-mp="156243xhzy23b">$19,00</p>
            <p className="text-sm font-semibold text-emerald-400" data-id="element-137" data-mp="157d7vxbfz9uf">
              🎉 Vous économisez $91,00 aujourd’hui
            </p>

            <div className="pt-4" data-id="element-138" data-mp="cg397lh4faqq">
              <CtaButton href="https://curiousmindshubfr.impultienda.ar/checkout" className="w-full sm:w-auto" data-id="element-139" data-mp="ch4wcobevnot">
                Oui ! Je veux tout pour seulement $19
              </CtaButton>
            </div>

            <ul className="mt-6 flex flex-col items-center gap-2 text-sm text-white/70 sm:flex-row sm:justify-center sm:gap-6" data-id="element-140" data-mp="hfpw6mmr45cq">
              {['Accès numérique immédiat', 'Les 3 bonus inclus', 'Paiement unique, sans abonnement'].map(t => <li key={t} className="flex items-center gap-1.5" data-id="element-141" data-mp="20dm503ab6o3z">
                  <CheckIcon className="h-4 w-4 text-emerald-400" aria-hidden="true" data-id="element-142" data-mp="25dgx2a5tljqm" />
                  {t}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-6 flex items-center justify-center gap-2 text-sm text-ink/50" data-id="element-143" data-mp="1vg2rx6pckhdm">
          <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-144" data-mp="2j6ga85i4r1v0" />
          Accès immédiat après l’achat · Plus de 40 938 téléchargements
        </p>
      </div>
    </section>;
}